<div class="container container-footer border-top">
  <div class="row pt-2 pb-2" style="background-color: #edeef0">
    <div class="col text-center cursor pt-1 pb-1 pl-0 pr-0" (click)="onMenuClick('PLACES')" *ngIf="!qrCodeScanned">
      <div>
        <i class="footericon footericon-home"></i>
      </div>
      <!--<label for="" class="m-0 fa-xs-small-70">Home</label>-->
    </div>
    <div class="col text-center cursor pt-1 pb-1 pl-0 pr-0" *ngIf="qrCodeScanned" style="opacity: 0.6;cursor: not-allowed;">
      <div>
        <i class="footericon footericon-home text-muted"></i>
      </div>
      <!--<label for="" class="m-0 fa-xs-small-70 text-muted">Home</label>-->
    </div>
    <div class="col text-center cursor pt-1 pb-1 pl-0 pr-0" (click)="onMenuClick('SCAN')">
      <div>
        <i class="footericon footericon-scan"></i>
      </div>
      <!--<label for="" class="m-0 fa-xs-small-70">Scan</label>-->
    </div>
    <div class="col text-center cursor pt-1 pb-1 pl-0 pr-0" (click)="onMenuClick('ORDERS')">
      <div>
        <i class="footericon footericon-orders"></i>
        <span class="badge badge-success">{{webstorage.sessionSt_order_count}}</span>
      </div>
      <!--<label for="" class="m-0 fa-xs-small-70">Orders</label>-->
    </div>
    <!--<div class="col text-center cursor pt-2 pb-1" *ngIf="qrCodeScanned" style="opacity: 0.6;cursor: not-allowed;">
      <div>
        <i class="fas fa-list" style="color: #a09f9f"></i>
        <span class="badge badge-success">{{webstorage.sessionSt_order_count}}</span>
      </div>
      <label for="" class="m-0 fa-xs-small-70">Orders</label>
    </div>-->
    <div class="col text-center cursor pt-1 pb-1 pl-0 pr-0" (click)="onMenuClick('PROFILE')">
      <div>
        <i class="footericon footericon-profile"></i>
      </div>
      <!--<label for="" class="m-0 fa-xs-small-70"></label>-->
    </div>
    <div class="col pull-right text-center cursor pt-1 pb-1 pl-0 pr-0" (click)="onMenuClick('CART')">
      <div>
        <i class="footericon footericon-cart"></i>
        <span class="badge badge-success">{{cartItemCount}}</span>
      </div>
      <!--<label for="" class="m-0 fa-xs-small-70"></label>-->
    </div>
  </div>
</div>
